import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=2d73d4be&scoped=true"
var script = {}
import style0 from "./pages.vue?vue&type=style&index=0&id=2d73d4be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73d4be",
  null
  
)

export default component.exports